import { __generator } from "tslib";
import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getGallectionDeviationStreamId } from '../helpers';
import { getCurrentMediaSource, getCurrentFolderId, getSearchQuery, getCurrentSubfolderId, } from '../selectors';
export default function () {
    var _a, mediaSource, folderId, subfolderId, searchQuery, streamId, isFetching;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    mediaSource: getCurrentMediaSource(state),
                    folderId: getCurrentFolderId(state),
                    subfolderId: getCurrentSubfolderId(state),
                    searchQuery: getSearchQuery(state),
                }); })];
            case 1:
                _a = _b.sent(), mediaSource = _a.mediaSource, folderId = _a.folderId, subfolderId = _a.subfolderId, searchQuery = _a.searchQuery;
                streamId = getGallectionDeviationStreamId(mediaSource, subfolderId || folderId, searchQuery);
                return [4 /*yield*/, select(selectors.isFetching, streamId)];
            case 2:
                isFetching = _b.sent();
                if (isFetching) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(withOffset.actions.fetch(streamId))];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=fetchMoreGallectionDeviations.js.map